import YouTubeClone from "../assets/png/Project/YouTube Clone.png";
import portfolio from "../assets/png/Project/portfoilo.png";
import MusicPlayerCard from "../assets/png/Project/MusicPlayer.jpg";
import CardGame from "../assets/png/Project/Card Game.png";
import RockPaperScissors from "../assets/png/Project/Rock Paper Scissors.png";
import weatherplatforms from "../assets/png/Project/DoctorzBook.png";
export const projectsData = [
  {
    id: 1,
    projectName: "YouTube Clone",
    projectDesc:
      "Create a comprehensive YouTube clone with multiple fnctionalities,  Developed Shorts, Explore, History, and Subscribers functionalities.  Enabled quick video search and streaming. Implemented a user-friendly interface for seamless navigation .",
    tags: ["ReactJS, TailwindCSS, Node.js, MongoDB"],
    code: "https://github.com/bulbul1434/",
    demo: "https://magnificent-gingersnap-aed87d.netlify.app",
    image: YouTubeClone,
  },

  {
    id: 2,
    projectName: "portfolio",
    projectDesc:
    "Developed a comprehensive portfolio, showcasing my projects, education, contact information, and resume. This portfolio highlights my technical skills, achievements, and professional experience in a visually appealing and interactive manner.",
    tags: ["React.JS"],
    code: "https://github.com/bulbul1434/",
    demo: " https://bulbul-portfolio1.netlify.app",
    image: portfolio,
  },
   
  {
    id: 3,
    projectName: "Music Player Card",
    projectDesc:
    "•	Designed and developed a responsive music player card. Embedded Spotify playlist for real-time music playback. Implemented a separate song search function allowing users to find and play songs. Playback controls: play, pause, next, previous, and like options.",
    tags: ["HTML, CSS, JavaScript and Spotify API"],
    code: "https://github.com/bulbul1434/Music-Player",
    demo: "https://musician-player.netlify.app ",
    image: MusicPlayerCard,
  },

  {
    id: 4,
    projectName: "Cards Game", 
    projectDesc:
      "Developed an interactive card game using ReactJS. The game involves matching pairs of cards and includes features like shuffling, flipping, and tracking the player’s score. This project helped in understanding state management and event handling in React.",
    tags: ["ReactJS"],
    code: "https://github.com/bulbul1434/Games",
    demo: "https://cards-moving-game.netlify.app",
    image: CardGame,
  },
  {
    id: 5,
    projectName: " Rock Paper Scissors",
    projectDesc:
      "Created an interactive “Rock Paper Scissors” game using HTML, CSS, and JavaScript. This project highlights my skills in JavaScript programming, DOM manipulation, and responsive web design.",
    tags: ["HTML, CSS, and JavaScript"],
    code: "https://github.com/bulbul1434/Rock-Paper-Scissors",
    demo: "https://rocks-paperr-scissors.netlify.app",
    image:  RockPaperScissors,
  },
  {
    id: 6,
    projectName: "weather-platforms",
    projectDesc:
      "Weather platforms give real-time updates and forecasts. They alert users to current and future weather conditions.",
    tags: ["HTML, CSS, and JavaScript"],
    code: "https://github.com/bulbul1434/",
    demo: "https://weather-platforms.netlify.app",
    image: weatherplatforms,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
